import { useSelector } from "react-redux";
import { useCallback, useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import Table from "../../../../../../common/components/table-manager/v1.1/table";
import _ from "lodash";
import PageLoader from "../../../../../../components/PageLoader";
import {orderData} from '../settlement-requests'

import { selectSettlementRequestCreatedItem, selectSettlementRequestDeletedItem, selectSettlementRequestsListItems, selectSettlementRequestTriggerItem, selectSettlementRequestUpdatedItem } from "../../../../../../redux/settlement-hub/settlement-requests/selector";
import { settlementRequests } from "../../../../../../redux/settlement-hub/settlement-requests/action";
import { SettlementRequestPopup } from "../components/settlement-requests-popup.component";
import { updateNestedValue } from "../../../../../../common/services/common.service";
import { MdTableView } from "react-icons/md";
import { SettlementRequestItemsPopup } from "../../settlement-request-items/containers/settlement-request-items-popup";
import { libraryData, NP_NP, TO_BE_INITIATED } from "../../constants/constants";
import { OrdersPopup } from "../components/orders-popup.component";
import DateRangePicker from "../components/date-range-picker";
import OrderFilterOptions from "../components/order-filter-options";
import { toast } from "react-toastify";

const SettlementRequests = ({
  
}: any) => {

  const dispatch = useAppDispatch()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const [showSettlementPopup, setShowSettlementPopup] = useState<boolean>(false);
  const [showOrdersPopup, setShowOrdersPopup] = useState<boolean>(false);
  const [selectedChoice, setSelectedChoice] = useState<string>('all');
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);

  const [showSettlementItemsPopup, setShowSettlementItemsPopup] = useState<boolean>(false);
  const [selectedSettlementRequests, setSelectedSettlementRequests] = useState<any>([]);
  const [selectedSettlementRequest, setSelectedSettlementRequest] = useState<any>(
    {
      "Id": 0,
      "OrderId": "",
      "CollectorAppId": "",
      "ReceiverAppId": "",
      "SettlementRequestTypeId": NP_NP,
      "SettlementRequestStatusId": TO_BE_INITIATED
    }
  );
  const [selectedOrders, setSelectedOrders] = useState<any>();
  const [listItems, setListItems] = useState<any>([]);
  const listOfSettlementRequestsData = useSelector(selectSettlementRequestsListItems)
  const createSettlementRequestsData = useSelector(selectSettlementRequestCreatedItem)
  const updateSettlementRequestsData = useSelector(selectSettlementRequestUpdatedItem)
  const deleteSettlementsRequestsData = useSelector(selectSettlementRequestDeletedItem)
  const triggerSettlementsRequestsData = useSelector(selectSettlementRequestTriggerItem)
  const [columnDefs, setColumnDefs] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'OrderId', headerName: 'Order Id', sortable: true, filter: true, filterType: 'text', },
      { field: 'CollectorAppId', headerName: 'Collector', sortable: true, filter: true, filterType: 'text', },
      { field: 'ReceiverAppId', headerName: 'Receiver', sortable: true, filter: true, filterType: 'text', },
      { field: 'SettlementRequestTypeId', headerName: 'Settlement Type' },
      { field: 'SettlementRequestStatusId', headerName: 'Status', sortable: true, filter: true, filterType: 'text', cellRenderer: 'libraryRendererComponent',
        cellRendererParams: { library: libraryData, menuKey: 'Value', menuValue: 'Description', callback: handleStatus, anchorPosition: 'top-left' },
      },
      {field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true, sortable: true, filter: true, filterType: 'date',},
      {field: 'ModifiedOnUtc', headerName: 'Updated On', isDateValueFormat: true, sortable: true, filter: true, filterType: 'date',},
      {field: '', headerName: 'Items', sortable: false, filter: false, cellRenderer: 'customFunctions'},

    ]);
  }

  const handleStatus = () => {

  }

  const handleInnerFormChange: any = ({path, value}: any) => {
    console.log('selectedSettlementRequest, path, value', selectedSettlementRequest, path, value)
    const updatedData = updateNestedValue(selectedSettlementRequest, path, value)

    console.log('updatedData', updatedData)
    setSelectedSettlementRequest({...updatedData});
  }

  const handleSetStartDate = useCallback((date: Date) => {
    setStartDate(date);
  }, []);

  const handleSetEndDate = useCallback((date: Date) => {
    setEndDate(date);
  }, []);

  const handleCreateSettlementRequest = () => {   
    console.log('selectedChoice', selectedChoice)
    switch (selectedChoice) {
      case 'all':
        setShowOrdersPopup(false)
        console.log('allPendingOrders',{option: 'allPendingOrders'})
        // createSettlementRequestForAllPendingOrders()
        break;
      case 'selected':
        setSelectedOrders([])
        setShowOrdersPopup(true)
        console.log('selectedOrders', {option: 'selectedOrders', orders: selectedOrders})        
        break;
      case 'range':
        setShowOrdersPopup(false)
        console.log('betweenDates', {option: 'betweenDates', startDate: startDate, endDate: endDate})
        // createSettlementRequestForOrdersBetweenDates(startDate, endDate)
        break
      default:
        setShowOrdersPopup(false)
        // console.log('allPendingOrders',{option: 'allPendingOrders'})
        // createSettlementRequest({option: 'allPendingOrders'})

    }
  }

  const createSettlementRequestForAllPendingOrders = () => {

  }

  const createSettlementRequestForSelectedOrders = async (ids: any) => {
    console.log('create request for orders: ', ids)
    await dispatch(settlementRequests.resetAction({actionType:'create'}))
    await dispatch(settlementRequests.create({
      url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/settlement-hub/settlement-requests`, entity: 'settlementRequests', jsonData: {
        "context": {
          
        },
        "Records": [
          {
            "OrderId": 0,
            "CollectorAppId": "buyerapp",
            "ReceiverAppId": "sellerapp",
            "SettlementRequestTypeId": 10,
            "SettlementRequestStatusId": 10,
            "IsSettlementRequestFromSelectedPeriod": false,
            "IsSettlementRequestfromLastRequest": false,
            "IsSettlementRequestfromOrders": true,
            "OrdersIds": ids,
            "StartDate": new Date(),
            "EndDate": new Date()
          }
        ]
      }
    }))
  }

  const createSettlementRequestForOrdersBetweenDates = (startDate: any, endDate: any) => {

  }
  

  const handleInitiateSettlement = async () => {
    const selectedRequests = _.map(selectedSettlementRequests, (item: any) => { return {Id: item.Id}})
    await dispatch(settlementRequests.resetAction({actionType:'trigger'}))
    await dispatch(settlementRequests.trigger({
      url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/settlement-hub/settlement-requests/settle_trigger`,
      entity: 'settlementRequests',
      jsonData: {
        Context:{},
        Records: selectedRequests
      }
    }));
    // toast.info('Successfully initiated settlement for the selected Settlement Requests.')
  }

  const handleReconciliation = () => {

  }


  const handleSelectMemoized = useCallback((data: any) => {
    if (JSON.stringify(selectedSettlementRequests) !== JSON.stringify(data)) {
      setSelectedSettlementRequests(data)
    }
  }, [selectedSettlementRequests]);

  // const handleSelect = (data) => {
  //   setSelectedSettlementRequest(data)
  //   // setShowSettlementPopup(true)
  // }

  const handleEdit = async (data: any) => {
    await setSelectedSettlementRequest(data)
    setShowSettlementPopup(true)
  }

  const handleDelete = async (data: any) => {
    // const ids = _.map(data, (item: any) => {return {Id: item?.SettlementRequest?.Id}})
    // console.log('ids',ids)

    await dispatch(settlementRequests.resetAction({actionType:'delete'}))    
    await dispatch(settlementRequests.delete({
      url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/settlement-hub/settlement-requests/delete`,
      entity: 'settlementRequests',
      jsonData: {
        Context:{},
        Records: [{Id: data?.SettlementRequest?.Id}]
      }
    }));
  }

  const additionButtons: any = [    
    {
      svg:<></>,
        // <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
        //   <title>Initiate Settlement</title>
        //   <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
        // </svg>,
      name: 'Initiate Settlement',
      callback: () => handleInitiateSettlement(),
    },
    // {
    //   svg:
    //     <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
    //       <title>Initiate Reconciliation</title>
    //       <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
    //     </svg>,
    //   name: 'Initiate Reconciliation',
    //   callback: () => handleReconciliation(),
    // },
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      // name: 'Reload',
      callback: () => handleReloadData(),
    },
  ];

  const handleSettlementRequestItems =(item: any) => {
    setShowSettlementItemsPopup(true)
  }

  const customFunctions = [
    {icon: <MdTableView className="text-gray-800 text-xl" />, callback: handleSettlementRequestItems, title: "Show Settlement Items"},
    // {icon: <MdTableView className="text-gray-800 text-xl" />, callback: handleSpecificationAttributeOptions, title: "Show Specification Attribute Options"},
  ];

  const handleReloadData = () => {
    listSettlementRequests();
  }

  const listSettlementRequests = async () => {
    await dispatch(settlementRequests.resetAction({actionType:'list'}))
    await dispatch(settlementRequests.list({
      url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/settlement-hub/settlement-requests/list`,
      entity: 'settlementRequests',
      jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
      }
    }))
  }

  const handleSaveSettlementRequest = async (selectedSettlementRequest: any) => {
    if (selectedSettlementRequest?.Id > 0) {
      await dispatch(settlementRequests.resetAction({actionType:'update'}))
      await dispatch(settlementRequests.update({
        url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/settlement-hub/settlement-requests`, entity: 'settlementRequests', jsonData: {
          Records: [
            {
              Context: {},
              Records: [{
                ...selectedSettlementRequest
              }]
            }
          ]
        }
      }))
    } else {
      await dispatch(settlementRequests.resetAction({actionType:'create'}))
      await dispatch(settlementRequests.create({
        url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/settlement-hub/settlement-requests`, entity: 'settlementRequests', jsonData: {
          Records: [
            {
              Context: {},
              Records: [{
                ...selectedSettlementRequest
              }]
            }
          ]
        }
      }))
    }
    closeModal();
    listSettlementRequests();
  }

  const closeModal = () => {
    setShowSettlementPopup(false)
  }

  const closeItemsModal = () => {
    setShowSettlementItemsPopup(false)
  }

  const closeOrdersModal = () => {
    setShowOrdersPopup(false)
  }

  const handleSelectedOrders = (data: any) => {
    setShowOrdersPopup(false)
    const orderIds = _.map(data, (item: any) => {return item.Id})
    createSettlementRequestForSelectedOrders(orderIds)
  }

  useEffect(() => {
    // if(listOfSettlementRequestsData?.isSuccess){
      if(listOfSettlementRequestsData?.result?.items && listOfSettlementRequestsData?.result?.items?.length > 0)
      {
        if (listOfSettlementRequestsData?.result?.items[0].Error){
          setListItems(orderData)          
        }   
        else {
          setListItems(listOfSettlementRequestsData?.result?.items)
        }     
      }  else {
        setListItems(orderData)
      }    
    // }
  }, [listOfSettlementRequestsData]);

  useEffect(() => {
    console.log('createSettlementRequestsData', createSettlementRequestsData)
    if(createSettlementRequestsData?.isSuccess){
      dispatch(settlementRequests.resetAction({actionType:'create'}))
      toast.info('Settlement request created successfully for the selected orders.')
    }
  }, [createSettlementRequestsData]);


  useEffect(() => {
    console.log('updateSettlementRequestsData', updateSettlementRequestsData)
    if(updateSettlementRequestsData?.isSuccess){
      dispatch(settlementRequests.resetAction({actionType:'update'}))
      toast.info('Settlement request updated successfully.')
    }
  }, [updateSettlementRequestsData]);

  useEffect(() => {
    console.log('deleteSettlementsRequestsData', deleteSettlementsRequestsData)
    if(deleteSettlementsRequestsData?.isSuccess){
      dispatch(settlementRequests.resetAction({actionType:'delete'}))
      toast.info('Settlement request deleted successfully.')
    }
    listSettlementRequests();
  }, [deleteSettlementsRequestsData]);

  useEffect(() => {
    console.log('triggerSettlementsRequestsData', triggerSettlementsRequestsData)
    if(triggerSettlementsRequestsData?.isSuccess){
      dispatch(settlementRequests.resetAction({actionType:'trigger'}))
      toast.info('Successfully initiated settlement for the selected settlement requests.')
    }
    listSettlementRequests();
  }, [triggerSettlementsRequestsData]);

  useEffect(() => {
    createColumnDefs()
    listSettlementRequests()
    dispatch(settlementRequests.resetAction({actionType:'create'}))
    dispatch(settlementRequests.resetAction({actionType:'update'}))
    dispatch(settlementRequests.resetAction({actionType:'delete'}))
    dispatch(settlementRequests.resetAction({actionType:'trigger'}))
  }, [pageData, pageSize])

  return (
    <>
      {
        showSettlementPopup ?
        <SettlementRequestPopup
            selectedSettlementRequest={selectedSettlementRequest}
            closeModal={closeModal}
            handleSaveSettlementRequest={handleSaveSettlementRequest}
            handleInnerFormChange={handleInnerFormChange}
          />: <></>
      }
      {
        showOrdersPopup ?
        <OrdersPopup 
          closeModal={closeOrdersModal}
          handleSelectedOrders={handleSelectedOrders}
        /> : <></>
      }
      {
        showSettlementItemsPopup ?
        <SettlementRequestItemsPopup
            selectedSettlementRequest={selectedSettlementRequest}
            closeModal={closeItemsModal}
            handleSaveSettlementRequest={handleSaveSettlementRequest}
            handleInnerFormChange={handleInnerFormChange}
          /> : <></>
      }
      {listOfSettlementRequestsData?.isLoading || deleteSettlementsRequestsData?.isLoading ? <PageLoader /> :
      <>
        <div>
          <OrderFilterOptions 
            setSelectedChoice={setSelectedChoice}
            setStartDate={handleSetStartDate}
            setEndDate={handleSetEndDate}
            selectedOrders={selectedOrders}
            handleCreateSR={handleCreateSettlementRequest}
          />
        </div>
        <Table
          columnData={columnDefs}
          enableFilter={true}
          rowData={listItems}
          setPageData={setPageData}
          setPageSize={setPageSize}
          paginationData={listOfSettlementRequestsData?.result?.pagination}
          onSelect={handleSelectMemoized}
          onEdit={handleEdit}
          onDelete={handleDelete}
          additionButtons={additionButtons}
          customFunctions={customFunctions}
          checkboxConfig={{
            allowMultiSelect: true,
            defaultSelectedIds: [],
            isDisabled: false,
            keyColumn: 'Id',
          }}
          headingName="Settlement Requests" />
      </>
      }
    </>
  );
};

export default SettlementRequests;


